'use strict';

function Config($stateProvider, $urlRouterProvider, $httpProvider, cfpLoadingBarProvider) {
    $httpProvider.interceptors.push('authInterceptor');
}

function Run($rootScope, $state, toaster, $injector) {
}


// rejestracja
angular.module("ll.partner.app", [
    'ngSanitize',
    'ui.router',
    'ui.bootstrap',
    'toaster',
    'ui.utils',
    'angular-table',
    'angularFileUpload',
    'autocomplete',
    'll.filter',
    'angular-loading-bar',
    'ngCookies',
    'll.mediamark',
    'll.client.consents'
])
    .factory('authInterceptor', [
        '$rootScope', '$q', '$cookies',
        function ($rootScope, $q, $cookies) {
            return {
                request: function (config) {
                    
                    // dodanie wylaczenia pobierania z cache
                    if (config.url.indexOf('partials') !== -1) {
                        var t = new Date().getTime();
                        config.url = config.url + '?t=' + t;
                    }

                    if ($cookies['x-auth-leaselink']) {
                        config.headers['x-auth-leaselink'] = $cookies['x-auth-leaselink'];
                    }
                    return config;
                }
            }
        }
    ])
    .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', 'cfpLoadingBarProvider', Config])
    .run(['$rootScope', '$state', 'toaster', '$injector', Run])
    .directive("llPartnerPanel", PartnerPanelDirective.Factory())
    .directive("llPartnerPanelMenu", PartnerPanelMenuDirective.Factory())
    .directive("llPartnerPanelContent", PartnerPanelContentDirective.Factory())
    .directive("llPartnerPanelRequestForm", PartnerPanelRequestFormDirective.Factory())
    .directive("llRequestForm", RequestFormDirective.Factory())
    .directive("emqNumber", NumberDirective.Factory())
    .directive("emqDataChooser", DataChooserDirective.Factory())
    .directive("emqAutoComplete", AutoCompleteDirective.Factory())
    .directive('ngProcessMultiSteps', clientDirectives.ngProcessMultiSteps.Factory())
    .directive('llFrontFooter', clientDirectives.FrontFooterDirective.Factory())
    .directive('llFrontHelp', clientDirectives.FrontHelpDirective.Factory())
    .directive('ngProcessSideDrawer', clientDirectives.ngProcessSideDrawer.Factory())
    .directive('ngFormValidation', FormValidationDirective.Factory())
    .controller("DataChooserModalCtrl", DataChooserModalCtrl)
    .service("RequestService", RequestService)
    .service("PartnerPanelService", PartnerPanelService)
    .service('SystemDataHelper', systemData.SystemDataHelperSrv);


angular.module('ll.filter', ['ngSanitize'])
    .filter('FormatNumber', FormatNumber)
    .filter('AspDateTime', AspDateTime)
    .filter('AspIsoDateTime', AspIsoDateTime)
    .filter('Empty', Empty)
    .filter('YesNo', YesNo)
    .filter('IdentificationDocumentTypeFilter', IdentificationDocumentTypeFilter)
    .filter('TypeOfDeliveryFilter', TypeOfDeliveryFilter)
    .filter('reverseRepeat', reverseRepeat)
    .filter('monthNumberToName', monthNumberToName)
    .filter('ItemStoreStatusesFilter', ItemStoreStatusesFilter)
    .filter('RoleNameFilter', ['SystemDataHelper', RoleNameFilter])
    .filter('ProcessStatusFilter', ProcessStatusFilter)
    .filter('RecordMessageFilter', RecordMessageFilter)
    .filter('AgreementDocumentTypeFilter', AgreementDocumentTypeFilter);